import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { showAlert } from "@utils/Alert";
import { ProviderInvoiceCategoryApi, ProviderInvoiceCategoryDataType } from "@/api/ProviderInvoiceCategoryApi";

const ProviderInvoiceCategoryIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await ProviderInvoiceCategoryApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'La Categoria de Compras no puedo ser eliminado');
    } else {
      showAlert('success', 'La Categoria de Compras fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  return (
    <PageContainer
      title="Lista de Categoria de Compras"
      backUrl="/user/dashboard-accounting"
      primaryActions={[
        {
          onClick: () => {
            navigate('/user/provider-invoices/category')
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<ProviderInvoiceCategoryDataType>
        ref={modelRef}
        fetchData={(...args) => ProviderInvoiceCategoryApi.fetchAll(...args)}
        filterProps={[
          {
            key: "codigo",
            filterType: "eq",
            type: "number"
          },
          {
            key: "title",
            filterType: "contains"
          }
        ]}
        secondaryProperties={[
          {
            key: "codigo",
          },
          {
            key: "title",
            title: "Nombre",
          },
          {
            key: "is_default",
            optionalHighlighted: (val: any) => { return val == "true" },
            highlightedText: "Predeterminada",
            nonHighlightedText: "No Predeterminada"
          }
        ]}
        listActions={[
          {
            href: "/user/provider-invoices/category/{:id}",
            actionTitle: "Editar Categoria de Compras",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Categoria de Compras",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Categoria de Compras",
              confirmMessage: "¿Seguro que desea eliminar esta Categoria de Compras?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default ProviderInvoiceCategoryIndex;
